import { graphql } from 'react-relay';

export default graphql`
  mutation authMutation($input: PackageTrackerAuthenticationMutationInput!) {
    packageTrackerAuthentication(input: $input) {
      success
      remainingAttempts
    }
  }
`;
